export { default as AirlineIcon } from './AirlineIcon.vue';
